import { configureStore } from '@reduxjs/toolkit';
import authReducer from './features/authSlice';
import modalReducer from './features/modelSlice';
import userReducer from './features/userSlice';
import organizationReducer from './features/organizationSlice';
import administratorRoleReducer from './features/administratorRoleSlice';
import vehicleReducer from './features/vehicleSlice';
import companyReducer from './features/companySlice';
import profileReducer from './features/profileSlice';
import getWorkshopAppointmentReducer from './features/workshopAppointmentsSlice';
import notificationReducer from './features/notificationSlice';
import alertsReducer from './features/alertsSlice';
import surveysReducer from './features/satisfactionsSurveysSlice';
import vehcileConfigReducer from './features/vehicleConfigSlice';
import paymentReducer from './features/paymentSlice';
import dmsReducer from './features/dmsSlice';

const store = configureStore({
  reducer: {
    auth: authReducer,
    modal: modalReducer,
    user: userReducer,
    organization: organizationReducer,
    adminRole: administratorRoleReducer,
    vehicles: vehicleReducer,
    company: companyReducer,
    profile: profileReducer,
    workShopAppointment: getWorkshopAppointmentReducer,
    notifications: notificationReducer,
    alerts: alertsReducer,
    surveys: surveysReducer,
    vehicleConfig: vehcileConfigReducer,
    payment: paymentReducer,
    DMS: dmsReducer,
  },
  devTools: true,
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
